/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Nationalities. List of the countries the user has nationality.
 */
export interface Country { 
    id?: number;
    isoAlpha2?: string;
    isoAlpha3?: string;
    isoNumeric?: number;
    fips?: string;
    internationalName?: string;
    preferredName?: string;
    languages?: string;
    capitalCode?: string;
    tld?: string;
    currency?: string;
    currencyName?: string;
    currencySymbol?: string;
    phonePrefix?: string;
    postalCodeFormat?: string;
    postalCodeRegEx?: string;
    organizeBySubRegion?: boolean;
    legalAge?: number;
    enabled?: boolean;
}

